import { RouteObject } from 'react-router-dom';
import HomePage from "../pages/HomePage";
import ListaUtentiResponsive from "../components/ResponsiveWrapper/ListaUtentiResponsive";
import { loader as ListaUtentiLoader } from "../pages/ListaUtenti";
import MessaggiResponsive from "../components/ResponsiveWrapper/MessaggiResponsive";
import ResetPasswordResponsive from "../components/ResponsiveWrapper/ResetPasswordResponsive";
import { statsRoutes } from "./statsRoutes";
import { ppvRoutes } from "./ppvRoutes";
import { wrestlersRoutes } from "./wrestlersRoutes";
import { arenasRoutes } from "./arenasRoutes";
import { beltsRoutes } from "./beltsRoutes";
import { adminRoutes } from "./adminRoutes";
import { cardsRoutes } from "./cardsRoutes";

export const appRoutes: RouteObject[] = [
  {
    index: true,
    element: <HomePage />
  },
  statsRoutes,
  adminRoutes,
  {
    path: 'list-users',
    element: <ListaUtentiResponsive />,
    loader: ListaUtentiLoader
  },
  {
    path: 'messaggi',
    element: <MessaggiResponsive />
  },
  {
    path: 'reset-password',
    element: <ResetPasswordResponsive />
  },
  ppvRoutes,
  wrestlersRoutes,
  arenasRoutes,
  beltsRoutes,
  cardsRoutes,
];
